//货主定金定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 支付方式
 */
class PaymentMethod extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const PAYMENT_METHOD = new PaymentMethod();

/**
 * 支付状态
 */
class PaymentState extends UltMeta {
    UNPAID = new Meta(1, "待支付");
    CONFIRMING = new Meta(2, "确认中");
    CONFIRMED = new Meta(3, "已确认");
}

export const PAYMENT_STATE = new PaymentState();
